import { normalizeNutritionData } from "../../helpers";
import { resolveNutritionContext } from "../../helpers/domain";
import DiarySum from "../diary/DiarySum";
import ChartRenderer from "./ChartRenderer";
import { getMealAmountAndUnit } from "../../helpers";

const NutritionCharts = ({
	data: response,
	items = [],
	showDesiredEnergy = true,
	showMealItems = true,
	showMacros = false,
	energyTitle = "Min Energifördelning (E %)",
}) => {
	const { energy, fat, other, calories, minerals_vitamins, desired_energy } =
		normalizeNutritionData(response, items) ?? {};

    const nutrition = response?.data?.nutrition

    const diarySum = {protein: nutrition?.Protein ?? 0, fat: nutrition?.Fett ?? 0, carbs: nutrition?.Kolhydrater ?? 0,  kcal: nutrition?.['Energi Kcal'] ?? 0}

	const pathname = window.location.pathname;
	const context = resolveNutritionContext({ response, pathname });

	return (
		<>
			{items.length > 0 && showMealItems && (
				<div className="nutrition-meal-items">
					<h3 className="bold-title">Livsmedel</h3>

					<ul>
						{items.map((item, index) => {
							const key = `${item.id ?? item.food_item_id ?? "x"}-${index}`;
							const amountAndUnit = getMealAmountAndUnit(item);

							return (
								<li key={key}>
									{amountAndUnit && <span className="bold-title">{amountAndUnit}</span>} -{" "}
									{item.name}
								</li>
							);
						})}
					</ul>
				</div>
			)}

			{showMacros && <DiarySum items={[diarySum]} isFoodItem={context === "food"} />}

			<div className={`energy-types ${showDesiredEnergy ? "multi-chart" : ""}`}>
				<div className="energy">
					<ChartRenderer data={energy} type="energy" context={context} title={energyTitle} />
				</div>

				{showDesiredEnergy && (
					<div className="energy">
						<ChartRenderer
							data={desired_energy}
							type="desired_energy"
							context={context}
							title="Önskad fördelning (E %)"
						/>
					</div>
				)}
			</div>

			<div className="nutrient-charts">
				<ChartRenderer data={fat} type="fat" context={context} />

				<ChartRenderer data={calories} type="calories" context={context} />

				<ChartRenderer data={other} type="other" context={context} />

				<ChartRenderer data={minerals_vitamins} type="vitamins" context={context} />
			</div>
		</>
	);
};

export default NutritionCharts;
